import { DateToShortReadableDate } from '@PetSureAustralia/petsure-react-ui-library/distLib/helpers';
import { DEFAULT_YEAR_VALUE } from '../constants/constants';

export const VetProviderTypes = ['MOBILEV', 'VETERINARY'];

export const GetVetsByPolicyNumber = ({ vetDetails, policyNumber }) => {
  return vetDetails.filter((vetDetail) => {
    return vetDetail.PetsTreated.some((pet) => pet.PolicyNumber === policyNumber);
  });
};

export const GetVetsByServiceProviderNumber = ({ vetDetails, providerNumber }) => {
  return vetDetails?.filter((vetDetail) => {
    return vetDetail.serviceProviderNumber === providerNumber;
  });
};

export const GetAddressParts = ({ vetDetail }) => {
  /*
    TODO: Update and standardise data structures - requires API changes
    Note: Dependending on which API endpoint returned the data it has different keys
    for the same information. Current implementation attempts to cater for this.
   */

  if (typeof vetDetail.AddressLine1 !== 'undefined') {
    const { AddressLine1, AddressLine2, suburb, state, postCode } = vetDetail;

    return [AddressLine1, AddressLine2, suburb, state, postCode].filter((addressPiece) => addressPiece !== '');
  }

  const { ServiceProviderAddress, Suburb, State, Postcode } = vetDetail;

  return [ServiceProviderAddress, Suburb, State, Postcode].filter((addressPiece) => addressPiece !== '');
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const formattedDate = DateToShortReadableDate(new Date(dateString));
  const dateParts = formattedDate.substring(3).split(' ');
  if (dateParts[1] === DEFAULT_YEAR_VALUE) {
    return '';
  }

  return formattedDate.substring(3);
};

export const getPetsTreated = (pet, formValues, isClaimVetDetails, activeVet) => {
  const fromMonth =
    formValues[`fromMonth-${pet.policyNumber}`] !== '' ? Number(formValues[`fromMonth-${pet.policyNumber}`]) : null;
  const fromYear =
    formValues[`fromYear-${pet.policyNumber}`] !== '' ? Number(formValues[`fromYear-${pet.policyNumber}`]) : null;
  const toMonth =
    formValues[`toMonth-${pet.policyNumber}`] !== '' ? Number(formValues[`toMonth-${pet.policyNumber}`]) : null;
  const toYear =
    formValues[`toYear-${pet.policyNumber}`] !== '' ? Number(formValues[`toYear-${pet.policyNumber}`]) : null;

  if (isClaimVetDetails && activeVet.VetId !== 0) {
    return {
      VetId: 0,
      CustomerClaimId: null,
      PetName: pet.name,
      PolicyNumber: pet.policyNumber,
      BrandPartner: null,
      FromMonth:
        fromYear !== null && fromMonth !== null ? new Date(Date.UTC(fromYear, fromMonth)).getMonth() + 1 : null,
      FromYear: fromYear,
      ToMonth: toYear !== null && toMonth !== null ? new Date(Date.UTC(toYear, toMonth)).getMonth() + 1 : null,
      ToYear: toYear
    };
  }

  return {
    PetName: pet.name,
    PolicyNumber: pet.policyNumber,
    FromDate: fromYear !== null && fromMonth !== null ? new Date(Date.UTC(fromYear, fromMonth)) : null,
    ToDate: toYear !== null && toMonth !== null ? new Date(Date.UTC(toYear, toMonth)) : null,
    PolicyServiceProviderLineNo: 0
  };
};

export const isValidDate = (dateString) => {
  if (!dateString) return false;

  const date = new Date(dateString);
  const year = date.getFullYear();

  return year.toString() !== DEFAULT_YEAR_VALUE;
};
